import { InputNumber } from "antd";

interface InlineDaysInputProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
}

// Always-visible bordered number field embedded mid-sentence (e.g. "...belum
// diperpanjang dalam [30] hari") — the rule's threshold IS this field, not a
// separate control elsewhere on the page. Commits on blur/Enter rather than
// every keystroke, so it doesn't refetch the report while still typing.
const InlineDaysInput = ({ value, onChange, min, max }: InlineDaysInputProps) => {
  const commit = (raw: string) => {
    const parsed = Number(raw);
    onChange(Number.isFinite(parsed) ? Math.min(max, Math.max(min, Math.round(parsed))) : value);
  };

  return (
    <InputNumber
      // Remounts if the committed value changes externally (e.g. clamped to
      // a different number than what was typed), so the field never shows a
      // stale number after a correction.
      key={value}
      size="middle"
      controls={false}
      min={min}
      max={max}
      defaultValue={value}
      onBlur={(e) => commit(e.target.value)}
      onPressEnter={(e) => (e.target as HTMLInputElement).blur()}
      style={{
        width: 76,
        textAlign: "center",
        fontWeight: 600,
        fontVariantNumeric: "tabular-nums",
      }}
    />
  );
};

export default InlineDaysInput;
